// import { Burger, Divider, Group, Select, Space } from '@mantine/core'
import { Divider, Select, Space } from '@mantine/core'
import Cookies from 'js-cookie'
import { useLayoutEffect, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { useRecoilState, useResetRecoilState } from 'recoil'

import logo from '../assets/images/bridge-ad_logo_clear.png'
import { PLAN_TYPE } from '../config/consts'
import useGetServiceList, { GetServiceListResponse } from '../hooks/api/useGetServiceList'
import { LocationDateTimeAtom } from '../hooks/useLocationDateTimeForm'
// import useSidebar from '../hooks/useSidebar'
import { ServiceAtom } from '../recoil/atoms'
// import HeaderMenu from './HeaderMenu'
import LogoutButton from './LogoutButton'

function Header() {
  const user = JSON.parse(Cookies.get('User') ?? '{}')
  // const { opened, toggle } = useSidebar()
  const { services, isLoading } = useGetServiceList()
  const [service, setService] = useRecoilState(ServiceAtom)
  const resetForm = useResetRecoilState(LocationDateTimeAtom)

  const serviceSet = useMemo(
    () =>
      services?.map((s: GetServiceListResponse) => ({
        value: s.serviceID.toString(),
        planType: s.planType,
        label: s.name,
      })) ?? [
        {
          value: '',
          planType: PLAN_TYPE.LJSDK_SUMMARY,
          label: '',
        },
      ],
    [services],
  )
  const handleChangeService = (value: string | null) => {
    if (value === null) return
    Cookies.set('User', JSON.stringify({ ...user, serviceId: value }))
    setService(serviceSet.find((s) => s.value === value) ?? { value: '', planType: PLAN_TYPE.LJSDK_SUMMARY, label: '' })
    resetForm()
  }

  useLayoutEffect(() => {
    if (!isLoading) {
      setService(serviceSet.find((s) => s.value === user.serviceId) ?? serviceSet[0])
    }
  }, [isLoading, setService, serviceSet, user.serviceId])

  // サービス選択のセレクトボックスをClearできるように、clearableを追加（tgradmin用）
  return (
    <>
      <div className='fixed w-screen h-16 bg-white z-[201] shadow-md'>
        <div className='h-full max-w-full mx-4 flex justify-between items-center'>
          {/* 左側 */}
          <div className='flex items-center min-w-[120px]'>
            <Link to='/dashboard'>
              <img className='w-32' src={logo} alt='tangerine' />
            </Link>
          </div>

          {/* 右側 */}
          <div className='flex items-center gap-4 overflow-hidden'>
            <span className='text-sm whitespace-nowrap'>{user.username}</span>
            <Divider orientation='vertical' />
            {!isLoading && (
              <Select
                className='min-w-[200px] max-w-[400px] flex-grow'
                leftSection={<span className='material-icons'>search</span>}
                data={serviceSet}
                value={service.value !== '' ? service.value : serviceSet[0].value}
                onChange={handleChangeService}
                searchable
                clearable
              />
            )}
            <LogoutButton />
          </div>
        </div>
      </div>
      <Space h={64} />
    </>
  )
}

export default Header
